import React from "react";
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// import { } from 'react-router';
import Home from "./Components/Home/Home"
import Mint from "./Components/Mint/Mint"

function App() {
  return (
    <>
      <Router>
        <React.Fragment>
          <Switch>
            <Route exact path='/' component={Home} />
            <Route exact path="/mint" component={Mint} />

          </Switch>
        </React.Fragment>
      </Router>
    </>
  );
}

export default App;
